<thr-loading [show]="loader.isLoading()"></thr-loading>
<thr-header-operative [agent]="user" [showBack]="showBack" (back)="onBack()">
    <span class="mr-3">{{ 'header.assignment'|translate }}</span>
</thr-header-operative>

<router-outlet></router-outlet>
